import { render, staticRenderFns } from "./RegisterSuccess.vue?vue&type=template&id=e82708ac&scoped=true&"
import script from "./RegisterSuccess.vue?vue&type=script&lang=ts&"
export * from "./RegisterSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterSuccess.vue?vue&type=style&index=0&id=e82708ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82708ac",
  null
  
)

export default component.exports